import React from "react";
import moment from "moment-timezone";
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Grid, CircularProgress, Pagination, PaginationItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ChangeLog, ChangeLogResponse, CredentialResponse } from "../services/Types";
import { defaultLimit } from "../services/Constatnts";
import { generateExecutedByValue } from "../services/CommonHelpers";

const timeZone = moment.tz.guess();

const useStyles = makeStyles({
  contentHolder: {
  },
  loaderHolder: {
    position: "relative",
    minHeight: "100px"
  },
  circularProgressLoader: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
});

const ChangeLogTable = ({
  userCredentials,
  changeLogs,
  handleChangeLogsPageChange,
  activeChangeLogPage
}: {
  userCredentials: CredentialResponse,
  changeLogs: ChangeLogResponse,
  handleChangeLogsPageChange: any,
  activeChangeLogPage: number
}) => {
  const classes = useStyles();
  const paginationCount = Math.ceil((changeLogs.count/defaultLimit));

  return (
    <Grid container spacing={2} className={classes.contentHolder}>
      <Grid item xs={12}>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Old</TableCell>
                <TableCell>New</TableCell>
                <TableCell>Executed By</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { 
                changeLogs ?
                changeLogs.items.map((changeLogItem: ChangeLog, index: number) => {
                  const executedBy = generateExecutedByValue(changeLogItem, userCredentials);
                  
                  return (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell >{moment(changeLogItem?.executedAt).tz(timeZone).format("L h:mm A z")}</TableCell>
                    <TableCell>{changeLogItem.type}</TableCell>
                    <TableCell>{changeLogItem.oldValue}</TableCell>
                    <TableCell>{changeLogItem.newValue}</TableCell>
                    <TableCell>{executedBy}</TableCell>
                  </TableRow>
                )})
                :
                <TableRow>
                  <TableCell colSpan={4}>
                    <div  className={classes.loaderHolder}>
                      <CircularProgress className={classes.circularProgressLoader}/>
                    </div>
                  </TableCell>
                </TableRow>
              
              }
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination 
          shape="rounded" 
          count={paginationCount} 
          defaultPage={activeChangeLogPage} 
          siblingCount={1} 
          boundaryCount={1} 
          onChange={(_, value) => handleChangeLogsPageChange(value)}
          renderItem={(item) => (
            <PaginationItem
              components={{ previous: () => (<span>Previous</span>), next: () => (<span>Next</span>) }}
              {...item}
            />
          )}
          />
      </Grid>
    </Grid>
  );
}

export default ChangeLogTable;